require('./bootstrap');
import 'bootstrap';
import 'popper.js';
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'owl.carousel';
import AOS from 'aos';
import 'magnific-popup';

require('./jquery.cookiebar');
require('./jquery.mapmarker');
require('./search');
require('./booking');
require('./wishlist');

(function ($) {

    "use strict";

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.cookieBar({
        fixed: true,
        message: $('body').data('cookie-bar'),
        policyURL: $('#policy-url').prop('href'),
        bottom: true,
        policyButton: true
    });

    AOS.init({
        once: true,
        startEvent: 'firstPaint'
    });

    if ($('.map_contact').length) {
        //set up markers
        let myMarkers = {
            "markers": [
                {"latitude": "37.10767", "longitude": "25.37456", "icon": "/img/map-marker.png"}
            ]
        };

        //set up map options
        $(".map_contact").mapmarker({
            zoom: 16,
            center: 'Naxos Vacation Rentals',
            markers: myMarkers
        });
    }

    $('#newsletter-frm').submit(function (e) {
        e.preventDefault();
        let $this = $(this);

        $('#submit-newsletter').prop('disabled', 'disabled');
        $('#submit-newsletter > .text').hide();
        $('#submit-newsletter > .error').hide();
        $('#submit-newsletter > .success').hide();
        $('#submit-newsletter > .loading').show();

        $.ajax({
            url: $this.attr('action'),
            method: $this.attr('method'),
            data: $this.serializeArray()
        }).done(function (data) {
            $('#submit-newsletter > .success').show();
        }).fail(function (xhr, error) {
            $('#submit-newsletter > .error').show();
        }).always(function () {
            $('#submit-newsletter').prop('disabled', '');
            $('#submit-newsletter > .loading').hide();
        });

        return false;
    });

    $('.btn-facebook').click(function (e) {
        FB.ui({
            display: 'popup',
            method: 'share',
            href: $(this).prop('href'),
        }, function(response){});
        e.preventDefault();
    });

    $(window).on('load', function () {
        $('[data-loader="circle-side"]').fadeOut();
        $('#preloader').delay(350).fadeOut(300, function () {
            document.dispatchEvent(new Event('firstPaint'));
        });

        $('.hero').addClass('start-bg-zoom');

        $('.new-properties-slider').owlCarousel({
            nav: false,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2
                },
                780: {
                    items: 3
                }
            }
        });

        $('.new-properties-slider .images').owlCarousel({
            nav: true,
            dots: false,
            items: 1,
            animateOut: 'fadeOut',
            lazyLoad: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false
        });

        $('.activities-slider').owlCarousel({
            nav: false,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 4
                }
            }
        });

        // Property carousels
        let carousel = $('#property .images');
        let thumbs = $('#property .owl-thumbs');
        carousel.owlCarousel({
            nav: true,
            dots: false,
            items: 1,
            lazyLoad: true,
            animateOut: 'fadeOut',
        }).on('changed.owl.carousel', function (el) {
            let current = el.item.index;
            thumbs.find('.owl-item').removeClass('current').eq(current).addClass('current');
            thumbs.data('owl.carousel').to(current, 100, true);
        });

        thumbs.on('initialized.owl.carousel', function () {
            thumbs.find('owl-item').eq(0).addClass('current');
        }).owlCarousel({
            items: 5,
            dots: false,
            nav: true,
            lazyLoad: true,
            margin: 4,
            responsive: {
                0: {
                    items: 3
                },
                600: {
                    items: 5
                }
            }
        }).on('changed.owl.carousel', function (el) {
            carousel.data('owl.carousel').to(el.item.index, 100, true);
        });

        thumbs.on('click', '.owl-item', function (e) {
            e.preventDefault();
            carousel.data('owl.carousel').to($(this).index(), 300, true);
        });
        carousel.magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1]
            },
        });

        $('.thumbs-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1]
            },
        });


        $('[data-bs-toggle="tooltip"]').tooltip();

        // Retrieve preferred currency
        $.getJSON($('select.currency-selector').data('endpoint'))
            .done(function (data) {
                var currency = data.currency;
                var $select = $('select.currency-selector');
                $select.val(currency).prop('selected', true);
            });

        $('select.currency-selector').on('change', function () {
            var $select = $(this);
            $.ajax($select.data('update-endpoint'), {
                type: 'POST',
                data: {
                    currency: $select.val()
                }
            }).done(function (data) {
                location.reload();
            });
        });

        //Go through each carousel on the page
        $('.owl-carousel').each(function() {
            //Find each set of dots in this carousel
            $(this).find('.owl-dot').each(function(index) {
                //Add one to index so it starts from 1
                $(this).attr('aria-label', index + 1);
            });
        });

        var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
        (function () {
            var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = 'https://embed.tawk.to/60216384c31c9117cb7708b0/1eu16plm4';
            s1.charset = 'UTF-8';
            s1.setAttribute('crossorigin', '*');
            s0.parentNode.insertBefore(s1, s0);
        })();
    });

    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 1) {
            $('#main-menu').addClass("sticky navbar-light").removeClass('navbar-dark');
            $('#toTop').show();
        } else {
            $('#main-menu').removeClass("sticky navbar-light").addClass('navbar-dark');
            $('#toTop').hide();
        }
    });

    //Scroll to top
    $(window).on('scroll', function () {
        'use strict';
        if ($(this).scrollTop() != 0) {
            $('#toTop').fadeIn();
        } else {
            $('#toTop').fadeOut();
        }
    });
    $('#toTop').on('click', function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
    });

})(window.$);
